import React from 'react';
import { Link } from 'react-router-dom';
import {  FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/products', label: 'Products' },
    { path: '/applications', label: 'Applications' },
    { path: '/events', label: 'Events' },
    { path: '/careers', label: 'Careers' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
<div className="flex items-center space-x-2">
  <Link to="/" className="block">
    <img 
      src="/images/logo/logo.png" 
      alt="R.S Equipments" 
      className="h-16 w-auto object-contain pt-2 pb-2 pl-4 pr-4" 
    />
  </Link>
</div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Leading provider of precision laboratory equipment and consumables for research, 
              clinical, and industrial applications since 2022.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-accent transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Brands</h3>
            <ul className="space-y-2">
              <li><Link to="/products?brand=rs-equipments" className="text-gray-300 hover:text-accent transition-colors text-sm">R.S Equipments</Link></li>
              <li><Link to="/products?brand=accumax" className="text-gray-300 hover:text-accent transition-colors text-sm">Accumax</Link></li>
              <li><Link to="/products?brand=neuation" className="text-gray-300 hover:text-accent transition-colors text-sm">Neuation</Link></li>
              <li><Link to="/products?brand=dlab" className="text-gray-300 hover:text-accent transition-colors text-sm">DLAB</Link></li>
              <li><Link to="/products?brand=sr-lab-instruments" className="text-gray-300 hover:text-accent transition-colors text-sm">SR LAB Instruments</Link></li>
              <li><Link to="/products?brand=delvac" className="text-gray-300 hover:text-accent transition-colors text-sm">Delvac</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="text-accent text-lg mt-1 flex-shrink-0" />
                <span className="text-gray-300 text-sm">
                  No. 5/13, Karunanidhi Street,<br />
                  West Mambalam Chennai-600033<br/>
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <FaPhone className="text-accent text-lg flex-shrink-0" />
                <span className="text-gray-300 text-sm">+91 9840168240 / +91 7358078463</span>
              </div>
              <div className="flex items-center space-x-3">
                <FaEnvelope className="text-accent text-lg flex-shrink-0" />
                <span className="text-gray-300 text-sm"> rs4equipments@gmail.com, rsequipments.marketing@gmail.com, sales.rsequipments@gmail.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} R.S Equipments. All rights reserved.
          </p>
          <div className="flex space-x-4 text-sm text-gray-400">
            <Link to="#" className="hover:text-accent transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-accent transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-accent transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;